import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TClassificationsStore, TJobsResponsePayload } from './types';

// ==========================================:
const getClassificationsState = (state: TStoreState): TClassificationsStore =>
	state.classifications;
export const getClassifications = createSelector(
	[getClassificationsState],
	(classifications: TClassificationsStore) => classifications,
);

// ====================================================:
export const getJobsList = createSelector(
	[getClassifications],
	(classifications: TClassificationsStore): TJobsResponsePayload => classifications.jobs,
);

// ====================================================:

export const getJobsListIsLoad = createSelector(
	[getClassifications],
	(classifications: TClassificationsStore): boolean => classifications.jobsLoading,
);

// ====================================================:
